import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectMyHomeId } from '../../selectors/page';
import { createSubscribe, SubscribeBanner } from '@cian/frontend-valuation-chat-subscribe-widget';
import { selectUserId } from '../../selectors/user';
import { requestAuthentication } from '../../actions/authentication';
import { TThunkDispatch } from '../../types/redux';

export const SubscribeWidgetContainer: React.FC = () => {
  const myHomeId = useSelector(selectMyHomeId) as number;
  const userId = useSelector(selectUserId);

  const dispatch = useDispatch<TThunkDispatch>();

  const handleClick = React.useCallback(() => {
    if (userId) {
      dispatch(createSubscribe({ myHomeId }));
    } else {
      dispatch(
        requestAuthentication({
          viewData: { headingType: 'subscribePriceChange' },
          onSuccess: () => dispatch(createSubscribe({ myHomeId })),
        }),
      );
    }
  }, [dispatch]);

  return <SubscribeBanner myHomeId={myHomeId} onCreateSubscribeClick={handleClick} />;
};
